import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import anchorme from "anchorme"; // ES6 / Typescript style imports
import { Telefono } from '../../models/fiesta.model copy';

/**
 * Generated class for the TelefonosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-telefonos',
  templateUrl: 'telefonos.html',
})
export class TelefonosPage {
  public telefonos:Array<Telefono>;
  public textoTelefonosAPartir:string;
  public nombrePueblo:string;
  public telefono:Telefono;

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController) {
    this.textoTelefonosAPartir =anchorme(this.navParams.get("telefonos"));
    this.nombrePueblo = this.navParams.get("nombrePueblo");
    this.telefono = new Telefono();
    this.telefonos = new Array<Telefono>();
    this.convertTextToArray(this.textoTelefonosAPartir);
  }
  //El algoritmo es una mierda pero está copiado de la app de android para no tener que reacerlo
  private convertTextToArray(telfs:string){
    let i = 0;
    while (i < telfs.length) {
      ///////TITULO TELEFONOS
      let ini = i;
      let fin = -1;
      /// Me muevo hasta encontrar un \n en el texto del Titulo, es decir, fin del titulo
      while (i < telfs.length && telfs.charAt(i) != '\n') {
        i++;
      }
      fin = i;
      //METO EL TITULO DEL TELEFONO EN EL OBJETO DE LA CLASE TELEFONOS
      if (i < telfs.length && fin > 0) {
        let titu = telfs.substring(ini, fin);
        this.telefono.nombre=titu;
      }
      //////DESCRIPCION TELEFONOS
      ini = ++i;
      let fin2 = -1;
      /// Continuo con las descripciones de los telefonos hasta encontrar un espacio \n\r DONDE NO HAY NADA
      ///EJEMPLO:
      /// POLICIA LOCAL	//TITULO
      /// TELEFONO: 091	//DESCRIPCION
      ////////////////////ESPACIO EN BLANCO \n\r
      /// BOMBEROS		//TITULO
      /// TELEFONO: 061 	//DESCRIPCION
      for (let k = i; k < telfs.length; ++k) {
        if (i < telfs.length && telfs.charAt(i) == '\n') {
          if (i + 1 < telfs.length && (telfs.charAt(i + 1) == '\n' || telfs.charAt(i + 1) == '\r')) {
            k = telfs.length;
          }
        }
        i++;
      }
      fin2 = i;
      //SIGNIFICA QUE TENGO DESCRIPCION Y LA METO EN EL OBJETO DE CLASE TELEFONOS
      if (i < telfs.length && fin2 > 0) {
        this.telefono.descripcion=telfs.substring(ini, fin2);
      }
      //AÑADO EL TELFONO CON TITULO Y DESCRIPCIÓN A LISTA PARA EL LISTVIEW
      if (i < telfs.length && this.telefono.nombre && this.telefono.descripcion && this.telefono.descripcion.length > 0)
        this.telefonos.push(this.telefono);

      this.telefono = new Telefono();
      if (i < telfs.length) {
        i = i + 2;
      }
    }
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad TelefonosPage');
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }

}



// WEBPACK FOOTER //
// ./src/pages/telefonos/telefonos.ts